export const c2Words = [
  {
    word: "ubiquitous",
    image: "https://images.unsplash.com/photo-1557683316-973673baf926",
    synonyms: ["omnipresent", "pervasive", "universal"],
    example: "Smartphones have become ubiquitous in modern society.",
    definition: "Present or existing everywhere at the same time."
  },
  {
    word: "meticulous",
    image: "https://images.unsplash.com/photo-1556139943-4bdca53adf1d",
    synonyms: ["precise", "thorough", "scrupulous"],
    example: "She is meticulous about every detail in her work.",
    definition: "Very careful and with great attention to detail."
  },
  {
    word: "conundrum",
    image: "https://images.unsplash.com/photo-1534751516642-a1af1ef26a57",
    synonyms: ["puzzle", "dilemma", "riddle"],
    example: "The decision presents a real conundrum for the committee.",
    definition: "A confusing or difficult problem or question."
  },
  {
    word: "unequivocal",
    image: "https://images.unsplash.com/photo-1601933470928-c3a9b405c779",
    synonyms: ["unambiguous", "clear", "definite"],
    example: "The answer was an unequivocal yes.",
    definition: "Leaving no doubt; clear and firm."
  },
  {
    word: "juxtapose",
    image: "https://images.unsplash.com/photo-1591189851972-3700f1825dc1",
    synonyms: ["contrast", "compare", "collocate"],
    example: "The film juxtaposes brutal scenes with moments of beauty.",
    definition: "To place things side by side to show contrast."
  },
  {
    word: "quintessential",
    image: "https://images.unsplash.com/photo-1504826260979-242151ee45a6",
    synonyms: ["typical", "perfect", "classic"],
    example: "She is the quintessential English teacher — kind, smart, and firm.",
    definition: "Representing the most perfect or typical example of something."
  },
  {
    word: "surreptitious",
    image: "https://images.unsplash.com/photo-1549923746-c502d488b3ea",
    synonyms: ["secret", "covert", "stealthy"],
    example: "He took a surreptitious glance at the notes.",
    definition: "Kept secret, especially because it would not be approved of."
  },
  {
    word: "altruism",
    image: "https://images.unsplash.com/photo-1494173853739-c21f58b16055",
    synonyms: ["selflessness", "generosity", "charity"],
    example: "True altruism is rare but beautiful.",
    definition: "The belief in or practice of disinterested and selfless concern for others."
  },
  {
    word: "disseminate",
    image: "https://images.unsplash.com/photo-1581091870636-4a76d6ae8a70",
    synonyms: ["spread", "circulate", "broadcast"],
    example: "The organization disseminates information about healthy living.",
    definition: "To spread or distribute widely, especially information."
  },
  {
    word: "idiosyncratic",
    image: "https://images.unsplash.com/photo-1523289333742-be1143f6b766",
    synonyms: ["quirky", "eccentric", "distinctive"],
    example: "His idiosyncratic approach to teaching made his classes memorable.",
    definition: "Peculiar or individual; characteristic of a specific person."
  },
  {
    word: "acquiesce",
    image: "https://images.unsplash.com/photo-1531259683007-016a7b628fc6",
    synonyms: ["agree", "consent", "comply"],
    example: "He acquiesced to her demands, albeit reluctantly.",
    definition: "To accept something without protest."
  },
  {
    word: "repercussion",
    image: "https://images.unsplash.com/photo-1601047032250-4a7fefad71c6",
    synonyms: ["consequence", "effect", "impact"],
    example: "The new law may have serious economic repercussions.",
    definition: "An unintended consequence of an event or action."
  },
  {
    word: "acrimonious",
    image: "https://images.unsplash.com/photo-1580428184662-9912bcdb65c4",
    synonyms: ["bitter", "hostile", "angry"],
    example: "The debate turned acrimonious very quickly.",
    definition: "Full of anger, arguments, and bad feeling."
  },
  {
    word: "ameliorate",
    image: "https://images.unsplash.com/photo-1603437873662-31d14d7a3904",
    synonyms: ["improve", "enhance", "alleviate"],
    example: "Steps were taken to ameliorate the poor working conditions.",
    definition: "To make something bad or unsatisfactory better."
  },
  {
    word: "catalyst",
    image: "https://images.unsplash.com/photo-1508168076051-1c1b5eb2955a",
    synonyms: ["stimulus", "impetus", "spark"],
    example: "Her speech was a catalyst for change in the community.",
    definition: "A person or thing that causes a change."
  },
  {
    word: "ephemeral",
    image: "https://images.unsplash.com/photo-1606851092236-1b64a2d68c13",
    synonyms: ["short-lived", "transient", "fleeting"],
    example: "Fashion trends are often ephemeral.",
    definition: "Lasting for a very short time."
  },
  {
    word: "magnanimous",
    image: "https://images.unsplash.com/photo-1549989479-277dc6a23749",
    synonyms: ["generous", "noble", "forgiving"],
    example: "He was magnanimous in victory, praising his opponent.",
    definition: "Very generous or forgiving, especially to a rival."
  },
  {
    word: "vindicate",
    image: "https://images.unsplash.com/photo-1567568407132-7bfb31e1ff2a",
    synonyms: ["justify", "clear", "absolve"],
    example: "The evidence vindicated her claim of innocence.",
    definition: "To clear someone of blame or suspicion."
  },
  {
    word: "obfuscate",
    image: "https://images.unsplash.com/photo-1500674425229-f692875b0ab7",
    synonyms: ["confuse", "complicate", "cloud"],
    example: "The report was written in a way that obfuscated the truth.",
    definition: "To make something unclear or unintelligible."
  },
  {
    word: "rescind",
    image: "https://images.unsplash.com/photo-1596464716121-2204c502a3e8",
    synonyms: ["revoke", "cancel", "repeal"],
    example: "The company rescinded the offer after reviewing his background.",
    definition: "To officially cancel or withdraw something."
  },
  {
    word: "insatiable",
    image: "https://images.unsplash.com/photo-1607746882042-944635dfe10e",
    synonyms: ["unquenchable", "greedy", "voracious"],
    example: "He had an insatiable appetite for adventure.",
    definition: "Impossible to satisfy."
  },
  {
    word: "panacea",
    image: "https://images.unsplash.com/photo-1600172454520-04ce58e2f90e",
    synonyms: ["cure-all", "remedy", "solution"],
    example: "Education is not a panacea for all social problems.",
    definition: "A solution or remedy for all difficulties or diseases."
  },
  {
    word: "dichotomy",
    image: "https://images.unsplash.com/photo-1532581140115-c4643d2d7f7b",
    synonyms: ["division", "contrast", "split"],
    example: "There is a clear dichotomy between theory and practice.",
    definition: "A division or contrast between two opposing things."
  },
  {
    word: "belittle",
    image: "https://images.unsplash.com/photo-1504197885-1b33f9f8cc2c",
    synonyms: ["disparage", "deprecate", "undervalue"],
    example: "He belittled her efforts in front of everyone.",
    definition: "To make someone or something seem less important."
  },
  {
    word: "innate",
    image: "https://images.unsplash.com/photo-1530122037265-a5f1f91d3b99",
    synonyms: ["inborn", "natural", "instinctive"],
    example: "She has an innate ability to connect with people.",
    definition: "Inborn or naturally present from birth."
  }
];
